import $ from 'jquery';
import { View } from 'backbone';
import template  from 'dashboard/forms/modal/confirmation-modal.ejs';

class MobileConfirmationModal extends View {

    initialize( opts ){
        super.initialize(opts);

        this.options = opts || {};

        this.el = '#confirmation-modal';

        $('body').append(this.$el);
    }


    closeModal(){
        $( this.el ).dialog("destroy").remove();
    }

    createNewDialog(){

        return new Promise( resolve => {
            this.$el.html(template(this.model.toJSON()));
            this.delegateEvents();

            let originalButtons = this.model.get('buttons');
            let buttons = originalButtons.map(button => {
                return {
                        text: button.text,
                        'class': 'btn-select-item',
                            click: () => {
                                resolve(button.resolve);
                                this.closeModal();
                            }
                        }
            });
       
            $(this.el).dialog({
                dialogClass: 'no-close',
                autoOpen: true,
                modal: true,
                resizable: false,
                closeOnEscape: false,
                height: this.model.get('height'),
                width: this.model.get('width'),
                buttons: buttons
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
        });
    }

    render() {
        this.closeModal();

        return this.createNewDialog();
    }
}

export default MobileConfirmationModal;
